import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex, Text, Icon } from 'react-orange-ui';

const Container = styled(Flex)`
  margin: 0.5rem 0 0 0;
`;

const StyledIcon = styled(Icon)`
  margin-right: 0.5rem;
`;

const Rule = ({
  label, status, name,
}) => {
  let textColor;
  let icon = 'tick';
  let iconColor;

  switch (status) {
    case 'error':
      textColor = 'red';
      iconColor = 'red';
      icon = 'delete';
      break;
    case 'validated':
      textColor = 'black';
      iconColor = 'green';
      break;
    default:
      textColor = 'grey';
      iconColor = 'grey';
  }
  return (
    <Container alignItems="center" id={`cnil-rule-${name}`}>
      <StyledIcon id={`cnil-icon-${name}`} className={status} icon={icon} color={iconColor} />
      <Text
        size="s"
        bold
        color={textColor}
        id={`cnil-label-${name}`}
        className={status}
      >
        {label}
      </Text>
    </Container>
  );
};

Rule.propTypes = {
  /** Password validator rules state */
  label: PropTypes.string.isRequired,
  /** Rule number */
  name: PropTypes.string.isRequired,
  /** String status rule */
  status: PropTypes.oneOf(['pending', 'error', 'validated']).isRequired,
};

export default Rule;
